import * as Factory from 'factory.ts'
import faker from 'faker'

import { APCreditCardTypes, CurrencyName } from '@webapp/models/enums'
import {
  type PunchOut,
  type PunchOutAuth,
  type PunchOutCartItem,
  type PunchOutCreditCard,
  type PunchOutGroup,
  type PunchOutSupplier,
} from '@webapp/models/PunchOut'
import { AccountMock } from './account.factory'
import { CurrencyMock } from './currency.factory'
import { CustomFieldValueMock } from './customfield.factory'
import { VendorMock } from './vendor.factory'

export const PunchOutAuthMock = Factory.Sync.makeFactory<PunchOutAuth>({
  login: faker.internet.userName(),
  punchout_domain: Factory.each(() => faker.random.word()),
  purchase_order_request_url: faker.internet.url(),
})

export const PunchOutCreditCardMock =
  Factory.Sync.makeFactory<PunchOutCreditCard>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.word()),
    number: Factory.each(() =>
      faker.random.number({ min: 1000, max: 9999 }).toString()
    ),
    type: APCreditCardTypes.VISA,
    vendor: {
      name: faker.company.companyName(),
    },
  })

export const PunchOutMock = Factory.Sync.makeFactory<PunchOut>({
  auth: PunchOutAuthMock.build(),
  creditcard: Factory.each(() => PunchOutCreditCardMock.build()),
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.word()),
  requesters: [],
  requesters_count: 0,
  test_mode: false,
  order_request_email_test: false,
})

export const PunchOutCartItemMock = Factory.Sync.makeFactory<PunchOutCartItem>({
  account: AccountMock.build(),
  currency: CurrencyMock.build({ name: 'CAD' }),
  quantity: Factory.each(() => String(faker.random.number())),
  name: faker.commerce.productName(),
  custom_fields: CustomFieldValueMock.buildList(0),
  lineComment: faker.lorem.sentence(),
  punchout_uuid: faker.random.uuid(),
  punchout_vendor_reference: 4,
  shipping_amount: Factory.each(() => String(faker.commerce.price())),
  tax_amount: Factory.each(() => String(faker.commerce.price())),
  unit: faker.commerce.productAdjective(),
  unit_price: Factory.each(() => String(faker.commerce.price())),
  vendor: Factory.each(() => VendorMock.build()),
})

export const PunchOutGroupMock = Factory.Sync.makeFactory<PunchOutGroup>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each((index) => `${faker.random.word()}__GroupName__${index}`),
  punchout_domain: Factory.each(() => faker.random.word()),
})

export const PunchOutSupplierMock = Factory.Sync.makeFactory<PunchOutSupplier>({
  supplier_id: 4,
  name: Factory.each(
    (index) => `${faker.random.word()}__SupplierName__${index}`
  ),
  country_code: Factory.each(() => faker.address.countryCode()),
  country_name: Factory.each(() => faker.address.country()),
  website_url: Factory.each(() => faker.internet.url()),
  punchout_domain: Factory.each(
    (index) => `${faker.internet.domainName()}__SupplierDomain__${index}`
  ),
  logo: Factory.each(() => faker.image.imageUrl()),
  icon: Factory.each(() => faker.image.imageUrl()),
  legal_name: Factory.each(() => faker.random.word()),
  shipping_location_ids_required: false,
  supported_protocol_methods: ['POSR', 'POOM', 'OR', 'CR'],
  sector: `${faker.random.word()} Sector`,
  test_mode_available: false,
  requires_customer_unique_webstore_url: false,
})
